import { render, staticRenderFns } from "./mateMore.vue?vue&type=template&id=be968f28&scoped=true&"
import script from "./mateMore.vue?vue&type=script&lang=js&"
export * from "./mateMore.vue?vue&type=script&lang=js&"
import style0 from "./mateMore.vue?vue&type=style&index=0&id=be968f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be968f28",
  null
  
)

export default component.exports